export default "__VITE_ASSET__B5T0ZUOD__"